export default {
  // Header
  'header.temple.name': '天竺禅院',
  'header.temple.english': '韩国佛教寺院',
  'header.menu.introduction': '寺院介绍',
  'header.menu.greeting': '问候',
  'header.menu.history': '历史',
  'header.menu.meaning': '意义',
  'header.menu.location': '位置',
  'header.menu.practice': '修行',
  'header.menu.pilgrimage': '朝圣',
  'header.menu.news': '新闻',
  'header.menu.resources': '资源',
  'header.menu.support': '支持',

  // Hero Section
  'hero.title': '欢迎来到天竺禅院',
  'hero.subtitle': '佛陀教法开始的圣地，印度祇园精舍',
  'hero.description': '天竺禅院是位于印度比哈尔邦王舍城的韩国佛教修行中心。我们在佛陀证悟后首次说法的圣地上行走禅修与修行之路。',
  'hero.button.visit': '参访信息',
  'hero.button.learn': '了解更多',

  // Daily Wisdom
  'wisdom.title': '每日法句经',
  'wisdom.original': '若以色見我 以音聲求我 是人行邪道 不能見如來',
  'wisdom.korean': '만약 나를 색(형상)으로 보려 하거나, 음성으로 찾으려 한다면, 그 사람은 삿된 길을 가고 있는 것이다. 그는 결코 여래를 볼 수 없다.',
  'wisdom.english': 'If you\'re trying to see me in colour, or in voice, he\'s on a dead path; he can never see the Buddha.',

  // Quick Links
  'links.title': '快速指南',
  'links.visit.title': '参拜时间',
  'links.visit.morning': '早课',
  'links.visit.morning.time': '04:00-06:00',
  'links.visit.evening': '晚课',
  'links.visit.evening.time': '18:00-19:00',
  'links.visit.lunch': '午餐时间',
  'links.visit.lunch.time': '12:00-13:00',
  'links.visit.contact': '参访前请联系',
  'links.visit.phone': '+91-892-313-9035',
  'links.visit.manager': '(总经理瓦尔丹)',
  'links.practice.title': '修行项目',
  'links.practice.meditation': '禅修',
  'links.practice.dharma': '法谈',
  'links.practice.retreat': '寺院住宿',
  'links.support.title': '支持',
  'links.support.regular': '定期捐赠',
  'links.support.onetime': '一次性捐赠',
  'links.support.volunteer': '志愿者',

  // News Section
  'news.title': '寺院新闻',
  'news.view': '查看详情',
  'news.date': '日期',

  // Footer
  'footer.about.title': '关于天竺禅院',
  'footer.about.description': '天竺禅院是位于印度王舍城的韩国佛教修行中心，佛陀的圣地。',
  'footer.contact.title': '联系方式',
  'footer.contact.address': '印度比哈尔邦王舍城',
  'footer.contact.phone': '电话',
  'footer.contact.email': '电子邮件',
  'footer.links.title': '快速链接',
  'footer.links.introduction': '介绍',
  'footer.links.practice': '修行',
  'footer.links.pilgrimage': '朝圣',
  'footer.links.support': '支持',
  'footer.hours.title': '参拜时间',
  'footer.hours.morning': '早课：04:00-06:00',
  'footer.hours.evening': '晚课：18:00-19:00',
  'footer.hours.lunch': '午餐：12:00-13:00',
  'footer.copyright': '© 2024 天竺禅院。保留所有权利。',
  'footer.powered': '网站建设',
};
